import { j as t } from "../../_virtual/jsx-runtime.js";
const i = ({
  width: o = 20,
  height: r = 20,
  viewBox: n = "0 0 20 20",
  fill: s = "currentColor",
  ...C
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: o,
    height: r,
    viewBox: n,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...C,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M9.76735 18.5625C5.16498 18.5625 1.43402 14.8315 1.43402 10.2292C1.43402 5.62683 5.16498 1.89587 9.76735 1.89587C14.3697 1.89587 18.1007 5.62683 18.1007 10.2292C18.1007 14.8315 14.3697 18.5625 9.76735 18.5625ZM9.76735 16.8959C13.4493 16.8959 16.434 13.9111 16.434 10.2292C16.434 6.54731 13.4493 3.56254 9.76735 3.56254C6.08545 3.56254 3.10069 6.54731 3.10069 10.2292C3.10069 13.9111 6.08545 16.8959 9.76735 16.8959ZM8.93402 12.7292H10.6007V14.3959H8.93402V12.7292ZM8.93402 6.06254H10.6007V11.0625H8.93402V6.06254Z",
        fill: s
      }
    )
  }
);
export {
  i as default
};
